import React, { ReactElement } from 'react';
import PageHeader from '@atlaskit/page-header';
import { Breadcrumbs } from '@css-xp/base';
import { PageContainer, PageHeaderContainer, BreadcrumbsContainer, Subheading } from './page-background-v2.styles';

interface PageBackgroundProps {
  className?: string;
  children?: ReactElement;
  heading?: React.ReactNode;
  breadcrumbsProps?: React.ComponentProps<typeof Breadcrumbs>;
  actions?: ReactElement;
  bottomBar?: ReactElement;
  subheading?: React.ReactNode;
}

/*
  The component is used to render a page wrapper similar to PageBackground but with a different UI. This is
  part of the new design iteration 2024. Design: https://hello.atlassian.net/wiki/spaces/tintin/pages/3307081579
*/
export const PageBackgroundV2 = ({
  className,
  children,
  heading,
  breadcrumbsProps,
  actions,
  bottomBar,
  subheading,
}: PageBackgroundProps) => {
  const componentClassName = `${className ?? ''}`.trim();

  const renderBreadcrumb = () => {
    if (!breadcrumbsProps?.items?.length) {
      return undefined;
    }

    return (
      <BreadcrumbsContainer>
        <Breadcrumbs {...breadcrumbsProps} />
      </BreadcrumbsContainer>
    );
  };

  return (
    <PageContainer data-testid="page-background-v2">
      <div className={componentClassName}>
        <PageHeaderContainer className="page-header-container">
          <PageHeader breadcrumbs={renderBreadcrumb()} actions={actions} bottomBar={bottomBar}>
            {heading}
            {subheading && <Subheading>{subheading}</Subheading>}
          </PageHeader>
        </PageHeaderContainer>
        {children}
      </div>
    </PageContainer>
  );
};
